<template>
  <div class="relative">
    <SideMenu />
    <slot />
    <SiteFooter />
  </div>
</template>
